import owd from 'owd/owd';

export default class SubmenuAppear extends owd.Component {
	init() {
		this.submenu = $('.submenu');
		this.bind();
	}

	bind() {
		this.on('click', this.dom.$window, () => {
			if (window.matchMedia('(max-width: 1359px)').matches) {
				this.submenu.slideToggle(200);
			}
		});
	}
}

owd.registerComponent('submenu-appear', {
	component: SubmenuAppear
});
 
